import { createAction } from '@reduxjs/toolkit';

import type { To } from 'Core/history';
import { pickObjectKeys } from 'Utils/array';

export const assignLocation = createAction<string>('ASSIGN_LOCATION');

export const replaceLocation = createAction<string>('REPLACE_LOCATION');

export const pushToHistory = createAction('PUSH_TO_HISTORY', prepareHistoryTo);

export const replaceInHistory = createAction('REPLACE_IN_HISTORY', prepareHistoryTo);

// History package uses object spread internally, but if we pass URL instance as a `to` argument,
// it spreads to an empty object. Thus we need to pick needed properties manually
function prepareHistoryTo(to: To, state: string | null) {
  return {
    payload: {
      state,
      location: typeof to === 'string' ? to : pickObjectKeys(to, ['pathname', 'search', 'hash']),
    },
  };
}
